import React from "react";
import Input from "./Input";
import { BlueLink, YellowButton } from "../buttons";
import { dummyClick, emptyFunction } from "../utilities";

const LoginForm = ({
  emailValue,
  errorMsg,
  handleEmailChange,
  handlePasswordChange,
  onKeyUp,
  onLoginClick,
  onPasswordForgottenClick,
  passwordValue,
  passwordForgottenPath,
  t
}) => (
  <div>
    <p>
      <Input
        value={emailValue}
        type="email"
        name="email"
        placeholder={t.email}
        onChange={handleEmailChange}
        onKeyUp={onKeyUp}
        autoFocus
        required
      />
    </p>
    <p>
      <Input
        value={passwordValue}
        type="password"
        name="password"
        placeholder={t.password}
        onChange={handlePasswordChange}
        onKeyUp={onKeyUp}
        required
      />
    </p>
    <p>
      <span className="fl red t-pl3">{errorMsg}</span>
      <BlueLink
        text={t.forgotPassword}
        className="db f--3 blue fr t-ml5 t-mr2 t-pl3-m t-ph1-ns t-pr2 t-pb2"
        path={passwordForgottenPath}
        onClick={onPasswordForgottenClick}
        target="_blank"
      />
    </p>
    <YellowButton
      text={t.login}
      className="w-90 mw6 px3 py1"
      onClick={onLoginClick}
    />
  </div>
);

export default LoginForm;
